import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../configureStore';
import { InFlightMessage } from '../interface/returnOps';
import { getInFlightMessages } from '../redux/reducer/returnOps';

const POLL_INTERVAL_MS = 30_000;

export const useInFlightSummary = () => {
    const dispatch = useDispatch<AppDispatch>();
    const messages = useSelector<RootState, InFlightMessage[]>(
        (state) => state.returnOps.inFlightMessages,
    );
    const loading = useSelector<RootState, boolean>(
        (state) => state.returnOps.loadingInFlight,
    );
    const pollRef = useRef<ReturnType<typeof setInterval> | null>(null);

    const activeCount = messages.filter(
        (m) => m.status === 'started' || m.status === 'processing',
    ).length;

    useEffect(() => {
        dispatch(getInFlightMessages());
        pollRef.current = setInterval(() => {
            dispatch(getInFlightMessages());
        }, POLL_INTERVAL_MS);

        return () => {
            if (pollRef.current) clearInterval(pollRef.current);
        };
    }, [dispatch]);

    return { activeCount, loading };
};

export default useInFlightSummary;
